import { Component, Input } from '@angular/core';
import { ACCOUNT_MENU } from '../../../menus/account-menu';
import { CommonModule } from '@angular/common';
import { Utilisateur } from '../../../../utilisateur/models/utilisateur';
import { ResolveRoutePipe } from '../../../pipes/resolve-route.pipe';
import { RouterLink } from '@angular/router';
import { HasAccessDirective } from '../../../directives/has-access.directive';

@Component({
  selector: 'p-account-menu',
  standalone: true,
  imports: [CommonModule, ResolveRoutePipe, HasAccessDirective, RouterLink],
  templateUrl: './p-account-menu.component.html',
  styleUrl: './p-account-menu.component.scss',
})
export class PAccountMenuComponent {
  readonly MENU = ACCOUNT_MENU;

  @Input() currentUser!: Utilisateur;

  showMenu = false;
}
